import styled from 'styled-components';
import { variant } from 'styled-system';
import { Text } from '../Text/Text';
import { LayoutProps } from '../../../theme/styledProps';
import { Theme } from '../../../theme/theme';

type SizeVariant = 'extraSmall' | 'small' | 'large';

interface AvatarProps {
  theme: Theme;
  size: SizeVariant;
  isAlt?: boolean;
}

export const Avatar = styled(Text)<AvatarProps>(
  ({ theme, isAlt }) => ({
    borderRadius: theme.radii.full,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 600,
    position: 'relative',
    flexShrink: 0,
    color: isAlt ? theme.colors.neutral['700'] : theme.colors.bg,
    borderColor: theme.colors.bg,
    borderWidth: 2,
    borderStyle: 'solid',
    verticalAlign: 'top',
    fontSize: theme.fontSizes.small,
    background: `linear-gradient(180deg, ${theme.colors.primary[500]} 0%, ${theme.colors.primary[100]} 100%)`,
  }),

  variant<LayoutProps, SizeVariant>({
    prop: 'size',
    variants: {
      extraSmall: {
        width: 26,
        height: 25,
      },

      small: {
        width: 40,
        height: 40,
      },

      large: {
        width: 65,
        height: 65,
      },
    },
  }),
);
